<div
  class="dataview-scroll"
  (scroll)="onScroll($event)"
  [class.can-scroll-up]="canScrollUp"
  [class.can-scroll-down]="canScrollDown">

  <div class="scroll-indicator scroll-indicator-top">
    <span class="material-symbols-rounded">keyboard_arrow_up</span>
  </div>

  <p-dataview [value]="rows">
    <ng-template #list let-items>
      @if (items.length > 0) {
        <div class="dataview-list">
          @for (item of items; track item.row.id; let index = $index) {
            <div class="dataview-item-wrapper">
              <div class="dataview-item"
                   [class.clickable]="config.rowAction"
                   (click)="onItemClick(item)">
                @if (item.iconLeft) {
                  <div
                    class="dataview-icon-container"
                    [style.background]="item.iconLeft.color">

                    @if (item.iconLeft.iconCode) {
                      <svg
                        class="dataview-svg-icon"
                        viewBox="0 -960 960 960"
                        aria-hidden="true">
                        <g [innerHTML]="byPass(item.iconLeft.iconCode)">

                        </g>
                      </svg>
                    }
                  </div>
                }

                <div class="dataview-main">
                    <div class="dataview-title-container">
                      @for (content of config.content; track content.key) {
                        <span [class]="content.class">
                          {{ item.row[content.key] ?? '-' }}
                        </span>
                      }
                    </div>

                    @if (item.rightTag) {
                      <p-tag
                        [value]="item.rightTag.name"
                        [severity]="item.rightTag.severity" />
                    }
                  </div>
              </div>
            </div>

            <!-- Break line Not for Last Element-->
            @if (index !== items.length - 1) {
              <hr class="break-line">
            }
          }
        </div>
      }
    </ng-template>
    <ng-template #emptymessage>
      @if (config.emptyIcon) {
        <div class="empty-icon">
          <span class="material-symbols-rounded">
            {{ config.emptyIcon }}
          </span>
        </div>
      }
      <div class="empty-message">
        {{ config.emptyMessage }}
      </div>
    </ng-template>
  </p-dataview>

  <div class="scroll-indicator scroll-indicator-bottom">
    <span class="material-symbols-rounded">keyboard_arrow_down</span>
  </div>
</div>